import {
  CHANGE_LOCALE,
  HOTEL_SETTINGS_GET,
  HOTEL_SETTINGS_SUCCESS,
  HOTEL_SETTINGS_ERROR,
  SHOW_TOAST_SET,
  GROUP_NAMES_GET,
  GROUP_NAMES_GET_SUCCESS,
  GROUP_NAMES_GET_ERROR
} from "../actions";

export const changeLocale = locale => {
  localStorage.setItem("currentLanguage", locale);
  return {
    type: CHANGE_LOCALE,
    payload: locale
  };
};

export const getHotelSettings = () => ({
  type: HOTEL_SETTINGS_GET,
  payload: {}
});

export const getHotelSettingsSuccess = items => ({
  type: HOTEL_SETTINGS_SUCCESS,
  payload: items
});

export const getHotelSettingsError = error => ({
  type: HOTEL_SETTINGS_ERROR,
  payload: error
});

export const setShowToast = visible => ({
  type: SHOW_TOAST_SET,
  payload: visible
});

export const getGroupNames = () => ({
  type: GROUP_NAMES_GET,
  payload: {}
});

export const getGroupNamesSuccess = items => ({
  type: GROUP_NAMES_GET_SUCCESS,
  payload: items
});

export const getGroupNamesError = error => ({
  type: GROUP_NAMES_GET_ERROR,
  payload: error
});
